import React, { useState, useEffect, useMemo } from "react";
import {
  Card,
  Grid,
  TextField,
  Autocomplete,
  IconButton,
  Checkbox,
  Skeleton,
  Typography,
  Button,
  CircularProgress,
  Chip,
  Link,
} from "@mui/material";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
// import PositionImageViewModal from './viewImageModal';
import CopyTranslation from "./components/copyTranslationModal";
import DeleteTranslationModal from "./components/deleteTranslationModal";
import {
  getTranslationsByLetterDO,
  getTranslationsByInputDO,
  deployTranslationsDO,
  updateContent,
  publishLangsDO,
} from "utils/translateUtils";
import { postLogDO, getLogForDeployDO, updateStatusDO } from "utils/logsUtils";
import { postNewAdminTaskDO } from "utils/adminUtils";
import { useMaterialUIController, addAlert, setCurrentDialog, useAuth, useBrands } from "context";
import { getAvailablePositionsDO } from "utils/positionsUtils";
import { TableColumnProps, TablePage } from "components/alove/TablePage";
import { TwoSizeChip } from "components/alove/Chips";
import { getTranslationsByStatusDO } from "utils/translateUtils";
import { BoRole, PermissionType } from "models/BO/BoRole";
import { getContents } from "utils/translationsUtils";
import { Translation, ContentModel, TrStatus } from "models/content/Translation";
import { networkGlobals } from "utils/networkUtils";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { useParams } from "react-router-dom";
import { camelCaseToCapitalizedWords } from "utils/globalsUtils";
import { PageNumber } from "../../accessNumbers";
import { Position } from "models/content/Position";
import { DialogType } from "components/alove/AloveDialog";
import { AddNewTranslationModal } from "./components/addNewTranslationModal";
import { AloveTextField } from "components/alove/AloveTextFields";

const MDSnackbar = require("components/MDSnackbar/index.js").default;
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

let letterFromSession = window.sessionStorage.getItem("translation_letter");

function Translations() {
const [isTranslation, setIsTranslation] = useState(false);
 
  const pageNumber = PageNumber.AppContent;

  const [controller, dispatch] = useMaterialUIController();
  const { currentUser, currentRole } = useAuth();
  
  const { currentBrand } = useBrands();
  const [newTranslations, setNewTranslations] = useState([] as any[]);
  
  
  const [positions, setPositions] = useState([] as Position[]);
  const [snackbar, setSnackbar] = useState({
    status: false,
    color: "success",
    icon: "check",
    title: "success",
    text: "",
  });
  const [refresh, setRefresh] = useState(false);
  const [changes, setChanges] = useState([] as any[]);
  const [canPublish, setCanPublish] = useState(false);


  useEffect(() => {
      getPosions()
  }, []);




  let { langCode } = useParams();

  useEffect(() => {
    setIsTranslation(!!langCode)
  }, [langCode]);

  const closeSnackBar = () => setSnackbar({ ...snackbar, status: false });


  const addChildren = (pos: Position, positions: Position[], sorted: Position[], level: number) => {
    pos.level = level;
    sorted.push(pos);
    const children = positions.filter((x) => x.parentId == pos.id);
    children.forEach((child, index) => addChildren(child, positions, sorted, level + 1));
  };

  const modelColumn = (params) => {
    switch (params.row.modelEntity) {
      case ContentModel.screen:
        return <Link href={`#/screens/${params.row.model?.id}`} color="primary" target="_blank">Screen</Link>;
      case ContentModel.comm:
        return <Link href={`#/communications/${params.row.model?.id}`} color="primary" target="_blank">Comm</Link>;
      case ContentModel.question:
        return <Link href={`#/questions/${params.row.model?.id}`} color="primary" target="_blank">Question</Link>;
      case ContentModel.answer:
        return <Link href={`#/questions/${params.row.question?.id}`} color="primary" target="_blank">Answer</Link>;
        case ContentModel.attribute:
          return <Link href={`#/attributes/${params.row.model?.id}`} color="primary" target="_blank">Attribute</Link>;
      default:
        return "";
    }
  };

  const getPosions = async () => {
    const positions = await getAvailablePositionsDO("content");
    const sorted = [];
    positions
      .filter((x) => !x.parentId)
      .forEach((pos, index) => addChildren(pos, positions, sorted, 0));

    setPositions(sorted);
  };

  const getTranslations = async (filters, page) => {

    if (!filters["Letter"] && !filters["Search"] && !filters["Status"] && !filters["Screen"] && !filters["notTranslated"]) {
      return []
    }

    const trs = await getContents({
      page: page,
      letter: filters["Letter"],
      search: filters["Search"],
      status: filters["Status"],
      position: filters["Screen"]?.id,
      notTranslated: filters["notTranslated"],
      langCode: langCode
    })
    setNewTranslations(trs);

    if (trs.find((x) => x.status === 1)) {
      setCanPublish(true);
    }
    return trs;
  };


  const buildPositions = (positionsValue: number[]): Position[] => {
    let returnedPositions = [] as Position[];
    if (positionsValue?.length && positionsValue[0] !== null) {
      for (let position of positionsValue) {
        const pos = positions?.find((p) => p?.id == position);
        if (pos !== undefined) {
          returnedPositions.push({ positionName: pos?.positionName } as Position);
        }
      }
      // ;
    }
    return returnedPositions;
  };

  const askToPublish = async () => {
    await postLogDO(
      "ask to publish",
      "tr",
      "translations",
      changes,
      currentUser?.id ? currentUser?.id : 0,
      currentBrand?.id,
      langCode
    );
    setRefresh(!refresh);
    setCanPublish(false);
    const postNewAdminTaskDOStatus = await postNewAdminTaskDO(
      "Deploy translations",
      "translations",
      currentUser?.id ? currentUser?.id : 0,
      "/dashboards/settings/translations"
    );
  };

  const letters = [
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
  ];


  const statusRender = (params) => {
    let color = "";
    let text = camelCaseToCapitalizedWords(TrStatus[params.row.status]);
    switch (params.row.status) {
      case 0:
        color = "error";
        break;
      case 1:
        color = "secondary";
        break;
      case 2:
        color = "warning";
        break;
      case 3:
        color = "success";
        break;
      case 4:
        color = "primary";
      default:
    }


    return <TwoSizeChip label={text} color={color as any} sizeoption="wide" />;
  };

  const renderPostions = (s) => {
    return positions
      ?.filter((x) => s.position?.includes(x.id))
      .map((x) => positionTooltip(x, <Chip label={x.positionName} size="small" sx={{ mr: 1 }} />));
  };

  const updatePosition = (id, value) => {
    const index = newTranslations.findIndex((x) => x.entityId === id);
    ;
    ;
    let positionIndexes = [] as any[];
    for (let val of value) {
      if (val?.id) {
        positionIndexes.push(val?.id);
      } else {
        positionIndexes.push(positions[index]?.id);
      }
    }
    ;
    const foundIndex = changes.findIndex((x) => x.key === newTranslations[index].entity_id);
    ;
    updateContent(newTranslations[index].entity_id, newTranslations[index].pre_validated, positionIndexes, langCode);

    let newChanges = changes;
    if (foundIndex === -1) {
      newChanges.push({
        key: newTranslations[index].entity_id,
        old: newTranslations[index].txt,
        new: newTranslations[index].pre_validated,
        position: positionIndexes,
      });
    } else {
      newChanges[foundIndex].position = positionIndexes;
    }
    setChanges(newChanges);

    ;

  };

  const processRowUpdate = async (newRow, oldRow) => {
    const field = isTranslation ? 'translation' : 'preValidated';
    if (newRow[field] !== oldRow[field]) {
      const updateStatus = await updateContent(newRow.entityId, newRow[field],newRow.positions,langCode);
      newRow.status = TrStatus.PendingPublish;
    }
    return newRow;                        
  };



  const publish = async () => {
    publishLangsDO(langCode).then((res) => {
      if (res) {
        addAlert(dispatch, "Translations were published");
        setRefresh(!refresh);
      }
    })
  };

  const CustomWidthTooltip = styled(({ className, ...props }:any) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))({
    [`& .${tooltipClasses.tooltip}`]: {
      maxWidth: 500,
    },
  });

  const rowActions = (s) => [
    <CopyTranslation
      translation={s}
      curentUser={currentUser}
      currentBrand={currentBrand}
      setSnackbar={setSnackbar}
      snackbar={snackbar}
    />,
    <IconButton size="small" disableRipple>
      <DeleteTranslationModal
        translation={s}
        currentBrand={currentBrand}
        setSnackbar={setSnackbar}
        snackbar={snackbar}
        getTranslationsByLetter={() => {}}
      />
    </IconButton>,
  ];

  const positionTooltip = (position, child) => {
    return (
      <CustomWidthTooltip
        placement="left-start"
        title={
          <a href={position.img} target="_blank" onClick={(e) => e.stopPropagation()}>
            <img src={position.img} height={500} width="auto" style={{ minWidth: 250 }} />
          </a>
        }
      >
        {child}
      </CustomWidthTooltip>
    );
  };

  const positionsDD = (onChange, s?):JSX.Element => (
     <Autocomplete
          sx={{ minWidth: 250, mt: s ? 1 : 0 }}
      isOptionEqualToValue={(positions, value) => positions?.positionName === value?.positionName}
      multiple={!!s}
      defaultValue={buildPositions(s?.position)}
      getOptionLabel={(option) => option.positionName}
      options={positions }
      limitTags={1}
      // onClick={() => {
      // }}
      disableCloseOnSelect
      onChange={(e, v) => onChange(v)}
      getOptionDisabled={(option) => option.level !== 2}
      renderOption={(props, option, { selected }) => {
        return (
          <li
            {...props}
            key={option.positionName}
            style={{ marginLeft: option.level ? 20 : 0, fontWeight: 900 - option.level * 400 }}
          >
            {positionTooltip(option, <img src={option.img} height={25} width="auto" />)}

            {option.level == 2 && (
              <Checkbox icon={icon} checkedIcon={checkedIcon} checked={selected} />
            )}
            {option.positionName}
          </li>
        );
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          // variant="standard"
          size={s ? "small" : "medium"}
          label="Screen"
          placeholder="More..."
        />
      )}
    />)
  
  const columns : TableColumnProps<Translation>[] = [
    {
      headerName: "Syntax",
      field: "entityId",
      flex: 2,
      minWidth: 100,
      hidden: (params) => !currentRole?.hasAccess(pageNumber, PermissionType.ViewAllOptions),
    },
    {
      headerName: isTranslation ? "English":"Old Text",
      field: "txt",
      flex: 4,
      minWidth: 200,
      hidden: (params) => !currentRole?.hasAccess(pageNumber, PermissionType.ViewAllOptions),
    },
    {
      headerName: "Text (Double click to edit)",
      field:isTranslation ? 'translation': "preValidated",
      flex: 8,
      minWidth: 200,
      editableCB: () => !!currentRole?.hasAccess(pageNumber, PermissionType.Edit),
      renderEditCell: (params) => (
        <div style={{
          position: 'absolute',
          zIndex: 1000,
          backgroundColor: 'white',
          boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
          borderRadius: '4px',
          minWidth: '200px'
        }}>
          <AloveTextField 
            noBorders
            value={params.row[params.field]} 
            onChange={(v) =>params.api.setEditCellValue({id: params.id, field: params.field, value: v})}
            
            
          />
        </div>
      )
    },
    {
      headerName: "Q",
      field: "question",
      width:70,
      hidden: (params) => !currentRole?.hasAccess(pageNumber, PermissionType.ViewAllOptions),
      renderCell: (params) => (
        params.row.question?.id &&
        <Tooltip title={params.row.question?.txt}>
        <Link href={`#/questions/${params.row.question?.id}`} color="primary" target="_blank">
          Q{params.row.question?.id}
        </Link>
        </Tooltip>
      )
    },
    {
      headerName: "Model",
      field: "modelEntity",
      width:70,
      hidden: (params) => !currentRole?.hasAccess(pageNumber, PermissionType.ViewAllOptions),
      renderCell: modelColumn
    },  
    {
      headerName: "Screen",
      field: "position",
      flex: 2,
      minWidth: 270,
      renderCell: (params) =>
        currentRole?.hasAccess(pageNumber, PermissionType.Manager)
          ? positionsDD((v) => updatePosition(params.id, v), params.row)
          : renderPostions(params.row),
    },
    {
      headerName: "Status",
      field: "status",
      flex: 2,
      minWidth: 100,
      renderCell: (p) => statusRender(p),
    },
    // {
    //   headerName: "Actions",
    //   field: "actions",
    //   flex: 1,
    //   minWidth: 50,
    //   renderCell: (params) => rowActions(params.row),
    // },
  ];


  return (
    <DashboardLayout>
      <DashboardNavbar />
      <TablePage
        refresh={refresh}
        title={isTranslation ? "Translations" : "Content"}
        table={{
          columns,
          loadNext: getTranslations,
          processRowUpdate: processRowUpdate,
          pagination: true,
          getRowId: (row) => row.entityId,
        }}
        actions={{
          title: isTranslation ? "Translations Actions" : "Content Actions",
          page: pageNumber,
          // filters: [
          //   <Autocomplete
          //     sx={{ width: 150 }}
          //     defaultValue="en"
          //     // onChange={(event, newValue) => {
          //     //     setHost(newValue);
          //     // }}
          //     disabled
          //     options={["en"]}
          //     renderInput={(params) => <TextField {...params} label="Language" />}
          //   />,
          // ],
          addActions: [
            {
              role: PermissionType.AddNew,
              label: "Content",
              variant: "contained",
              onClick: () => {
                setCurrentDialog(dispatch, DialogType.AddNewTranslation);
              },
            },
          ],
          saveActions: [
            currentRole?.hasAccess(pageNumber, PermissionType.Publish) ?
            {
              label: "Publish",
              variant: "contained",
              onClick: publish,
            }:
            {
              label: "Ask to publish",
              role: PermissionType.AskToPublish,
              onClick: askToPublish,
              disabled: !canPublish,
              variant: "contained",
            }
          ],
        }}
        filters={[
          {
            label: "Search",
            type: "search",
            placeholder: "Search...",
          },

          {
            label: "notTranslated",
            hidden: !isTranslation,
            type: 'switch',
          },
          {
            label: "Screen",
            renderFilter: positionsDD,
          },
          {
            label: "Status",
            options: [
              { key: 1, label: "Pending Publish" },
              { key: 2, label: "Pending Approval" },
              { key: 4, label: "New" },
            ],
          },
          {
            label: "Letter",
            options: letters.map((l) => ({
              key: l,
              label: l,
            })),
            defaultValue: letterFromSession
              ? { key: letterFromSession, label: letterFromSession }
              : null,
          },
        ]}
        rerenderKey={JSON.stringify(positions)}
      />

      <MDSnackbar
        color={snackbar?.color ? snackbar?.color : "success"}
        icon={snackbar?.icon ? snackbar?.icon : "check"}
        title={snackbar?.title ? snackbar?.title : "success"}
        content=""
        dateTime=""
        open={snackbar.status}
        onClose={closeSnackBar}
        close={closeSnackBar}
      />
      <AddNewTranslationModal
        positionsDropdownRender={positionsDD}
        refresh={() => setRefresh(!refresh)}
      />
    </DashboardLayout>
  );
}

export default Translations;
